import type { CrownRank } from './daily-standings';

const crownPresentation = {
  1: { label: 'Goldene Krone', color: 'gold' },
  2: { label: 'Silberne Krone', color: 'silver' },
  3: { label: 'Bronzene Krone', color: 'bronze' },
} as const satisfies Record<CrownRank, { label: string; color: string }>;

export function DailyCrown({ rank }: { rank: CrownRank }) {
  const presentation = crownPresentation[rank];

  return (
    <span
      className={`participant-crown participant-crown--${presentation.color}`}
      role="img"
      aria-label={`${rank}. Platz: ${presentation.label}`}
      title={`${rank}. Platz`}
    >
      <svg viewBox="0 0 24 20" aria-hidden="true">
        <path d="M2.2 5.1 7.4 9l4.6-7 4.6 7 5.2-3.9-2 11.1H4.2L2.2 5.1Z" />
        <path d="M4.7 18h14.6" />
      </svg>
    </span>
  );
}
